import { FieldShell } from './FieldShell';
import type { FieldComponentProps } from './types';

const splitInterval = (v: unknown): [string, string] => {
  if (typeof v !== 'string') return ['', ''];
  const m = /^(\d{2}:\d{2})-(\d{2}:\d{2})$/.exec(v);
  return m ? [m[1], m[2]] : ['', ''];
};

const joinInterval = (start: string, end: string): string => {
  if (!start && !end) return '';
  return `${start}-${end}`;
};

export const TimeIntervalField = ({ field, value, error, onChange }: FieldComponentProps) => {
  const [start, end] = splitInterval(value);

  return (
    <FieldShell field={field} error={error}>
      <div className="flex items-center gap-2">
        <input
          type="time"
          aria-label={`${field.display_title || field.title} start time`}
          className="form-input"
          value={start}
          onChange={(e) => onChange(joinInterval(e.target.value, end))}
        />
        <span className="text-rgf-gray-500">→</span>
        <input
          type="time"
          aria-label={`${field.display_title || field.title} end time`}
          className="form-input"
          value={end}
          onChange={(e) => onChange(joinInterval(start, e.target.value))}
        />
      </div>
    </FieldShell>
  );
};
